module.exports = __webpack_public_path__ + "media/images/flags/ht-618571b8fc30d19b022536ef372c10e4.svg";